export enum LoginView {
  PROVIDE_EMAIL = 'PROVIDE_EMAIL',
  EMAIL_PASSWORD = 'EMAIL_PASSWORD',
  SSO = 'SSO',
  SSO_EMAIL_PASSWORD = 'SSO_EMAIL_PASSWORD',
}
